export default [
    // 库存分配
    {
        path: "stockdistribution/modal",
        name: "stockDistributionModal",
        component: () => import(/* webpackChunkName: "stockdistribution" */ "@/views/stockdistribution/modal"),
    },
    {
        path: "stockdistribution/list",
        name: "stockDistributionList",
        component: () => import(/* webpackChunkName: "stockdistribution" */ "@/views/stockdistribution/index"),
    },
    {
        path: "stockdistribution/update/:type",
        name: "stockDistributionUpdate",
        component: () => import(/* webpackChunkName: "stockdistribution" */ "@/views/stockdistribution/update"),
    }
]